import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";

export class Reporter extends Phaser.Group {

    private reporterSprite: Phaser.Sprite;
    private reporterHiddenLimit: number;
    private isRight: boolean;
    private hideTimeEvent: Phaser.TimerEvent;
    private updateHidingReporterFunction: Function;

    constructor(game: Phaser.Game) {

        super(game, null, "reporter", false);

        this.isRight = Math.random() > .5 ? true : false;

        this.reporterSprite = new Phaser.Sprite(this.game, 0, GameConstants.GAME_HEIGHT, "texture_atlas_1");
        this.reporterSprite.visible = false;
        this.reporterSprite.anchor.setTo(0, 1);
        this.add(this.reporterSprite);

        this.updateHidingReporterFunction = () => {

            this.reporterSprite.y += 15;

            if (this.reporterSprite.y > this.reporterHiddenLimit) {
                this.reporterSprite.visible = false;
                this.update = function (): void {
                    //
                };
            }
        };
    }

    public onGoal(): void {

        if (this.reporterSprite.visible) {
            return;
        } else {
            if (this.hideTimeEvent !== null) {
                this.game.time.events.remove(this.hideTimeEvent);
            }
        }

        let r = Math.random();

        if (r < .3) {
            this.reporterSprite.frameName = "speaker0001";
        } else if (r < .6) {
            this.reporterSprite.frameName = "speaker0002";
        } else {
            this.reporterSprite.frameName = "speaker0003";
        }

        if (this.isRight) {
            this.reporterSprite.x = 0;
            this.reporterSprite.y = GameConstants.GAME_HEIGHT;
            this.reporterSprite.scale.setTo(1, GameVars.scaleY);
        } else {
            this.reporterSprite.x = 768;
            this.reporterSprite.y = GameConstants.GAME_HEIGHT;
            this.reporterSprite.scale.setTo(-1, GameVars.scaleY);
        }

        this.isRight = !this.isRight;

        this.reporterHiddenLimit = this.reporterSprite.height + GameConstants.GAME_HEIGHT;
        this.reporterSprite.visible = true;

        this.hideTimeEvent = this.game.time.events.add(1500, function () {
            this.update = this.updateHidingReporterFunction;
            this.hideTimeEvent = null;
        }, this);
    }
}
